import Vue from 'vue'

import Message from 'vue-m-message'
import 'vue-m-message/dist/index.css'
Vue.use(Message, { name: 'toase' })

// 补充一个普通调用，可以直接传字符串参数，不带icon和关闭按钮
Vue.prototype.$toase.push = (message, callback) => {
  const option = {
    message,
    wrapperClassName: 'no-icon'
  }
  if (typeof(callback) === 'function') option.onClose = callback
  return Vue.prototype.$toase(option)
}

// 补个样式进去
document.head.insertAdjacentHTML('beforeend', `<style>
  .m-message--description{line-height:25px}
  .no-icon .m-message-icons,
  .no-icon .m-message--control{display:none}
</style>`)